import './main.css'

import Alpine from 'alpinejs'
import pdfDownload from './pdfDownload'

Alpine.data('pdfDownload', pdfDownload)

window.Alpine = Alpine
Alpine.start()
